<template>
    <fieldset class="add-more" >
        <div class="header">
            <i class="fa fa-pencil" aria-hidden="true" @click="editContact" v-show="!editing"></i>
            <i class="fa fa-trash" aria-hidden="true" @click="deleteContact"></i>
        </div>
        <div class="text">
            <label for="full-name">Full Name</label>
            <input v-model="record.fullName" type="text" id="full-name" v-show="editing">
            <span class="static" v-show="!editing">{{ record.fullName }}</span>
        </div>
        <div class="text">
            <label for="job-title">Job Title</label>
            <input v-model="record.jobTitle" type="text" id="job-title" v-show="editing">
            <span class="static" v-show="!editing">{{ record.jobTitle }}</span>
        </div>
        <div class="text">
            <label for="email">Email</label>
            <input v-model="record.email" type="text" id="email" v-show="editing">
            <span class="static" v-show="!editing">{{ record.email }}</span>
        </div>
        <div class="flex">
            <div class="text">
                <label for="phone">Phone</label>
                <input v-model="record.phone" type="text" id="phone" v-show="editing">
                <span class="static" v-show="!editing">{{ record.phone }}</span>
            </div>
            <div class="text">
                <label for="fax">Fax</label>
                <input v-model="record.fax" type="text" id="fax" v-show="editing">
                <span class="static" v-show="!editing">{{ record.fax }}</span>
            </div>
        </div>
    </fieldset>
</template>


<script>
    import ClockvineMixin from 'vue/common/clockvine-mixin';
    import Vue from 'vue';

    export default {

        mixins: [ClockvineMixin],

        data: function() {
            return {
                type: 'seismicDesignContact',
                editing: this.id === null
            };
        },

        computed: {
            urlParams() {
                return {
                    seismicDesignId: this.record.seismicDesignId
                }
            }
        },

        watch: {
            record: {
                handler: function() {
                    this.$emit('sync-contact', { uid: this.uid, ...this.record });
                },
                deep: true
            },
        },

        props: [
            'uid',
        ],

        methods: {
            editContact() {
                this.editing = true;
                this.$emit('editing-contact', this.uid);
            },

            deleteContact() {
                this.$emit('delete-contact', this.uid);
            }
        }
    };

</script>
